import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '../../auth/services/app-config.service';
import { Observable, throwError } from 'rxjs';
import { CategoriesItem, PointOfInterest } from '../categories/categories.model';
import { catchError } from 'rxjs/operators';
import { BasePaginatedResponse } from '../paginated/base.paginated.response.model';

export interface ResponseData {
  label: string,
  data: CategoriesItem[]
}

@Injectable({
  providedIn: 'root'
})
export class SubcategoryService {

  private backendUrl: string = `${this.appConfig.config.baseUrl}${this.appConfig.config.backendUrl}`;

  private handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }

  constructor( private http: HttpClient, private appConfig: AppConfigService) { }
  
  getCategory(id: number): Observable<any> {
    return this.http
      .get<ResponseData>(
        `${this.backendUrl}/categories/${id}`, 
        {observe: 'response'},
      ).pipe(
        catchError(this.handleError)
      );
  }
  getPoisPaginated(id: number, page: number, size: number): Observable<BasePaginatedResponse<PointOfInterest>> {
    return this.http
      .get<BasePaginatedResponse<PointOfInterest>>(
        `${this.backendUrl}/pois/paginated/${id}?page=${page}&size=${size}`
        )
  }
  getCategoyList(): Observable<any> {
    return this.http
      .get<ResponseData>(
        `${this.backendUrl}/categories/list`, 
        {observe: 'response'},
      ).pipe(
        catchError(this.handleError)
      );
  }
  deleteCat(id:number): Observable<any> {
    return this.http.put(
      `${this.backendUrl}/categories/${id}`,
      {observe: 'response'}
    ).pipe(
      catchError(this.handleError)
    );
  }
  exportCsv(id: number): Observable<any> {
    return this.http
      .get(
        `${this.backendUrl}/report/csv?categoryid=${id}`, 
        {responseType: 'text'},
      ).pipe(
        catchError(this.handleError)
      );
  }

  bulkLoadStatus(id: any): Observable<any> {
    return this.http
      .get(
        `${this.backendUrl}/pois/bulkloadstatus/${id}`,
      ).pipe(
        catchError(this.handleError)
      );
  }
}
